import { SignInButton, useAuth } from '@clerk/react';
import type { ReactNode } from 'react';
import { PageLoading } from './PageLoading';

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  // Admin-token mode intentionally has no ClerkProvider. In that mode route
  // protection is handled by the Worker API's admin auth, so this wrapper is a
  // no-op and must not call Clerk hooks.
  if (!clerkPublishableKey) {
    return <>{children}</>;
  }

  return <ClerkProtectedRoute>{children}</ClerkProtectedRoute>;
}

function ClerkProtectedRoute({ children }: ProtectedRouteProps) {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return <PageLoading />;
  }

  if (!isSignedIn) {
    return (
      <main className="login-page" style={{ minHeight: '100vh' }}>
        <section className="login-card" role="alert" aria-live="polite">
          <div className="brand-mark large">A</div>
          <h1>AetherProxy Dashboard</h1>
          <p>Sign in with Clerk to access this protected dashboard route.</p>
          <SignInButton mode="modal">
            <button className="primary" type="button">
              Sign in
            </button>
          </SignInButton>
        </section>
      </main>
    );
  }

  return <>{children}</>;
}
